module.exports = __webpack_public_path__ + "img/hr-rail-chain-signal-metal.762d14e5.png";